import React, { useEffect } from 'react'
import gsap from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'
import CSSRulePlugin from 'gsap/CSSRulePlugin'
function Project() {
  
    useEffect(() => {

        gsap.registerPlugin(ScrollTrigger);

        let height = document.querySelector('.parent').clientHeight
        let sectionsText1 = gsap.utils.toArray(".smalltext1 > div");
        let sections1 = gsap.utils.toArray(".block1 > div");
        let sections2 = gsap.utils.toArray(".block2 > div");
        let sections3 = gsap.utils.toArray(".block3 > div");
        let sectionsMain = gsap.utils.toArray(".big-block > div");
        
        // I figured this config object would make it easier for you to hook into
        let config = {
          start: 0.6666, // 66% of the viewport
          end: 0.3333,   // 33% of the viewport
          onEnter: el => gsap.to(el, {opacity: 1}),
          onLeave: el => gsap.to(el, {opacity: 0.1}),
          onEnterBack: el => gsap.to(el, {opacity: 1}),
          onLeaveBack: el => gsap.to(el, {opacity: 0.1})
        };
        
        function animateSection(sections, config, reverse) {
          let actionsTL = gsap.timeline();
          let scrollTween = gsap.timeline({
                scrollTrigger: {
                    trigger: ".parent",
                    pin: true,
                    scrub: 1,
                    onRefresh: self => {
                      actionsTL.clear(); // remove all existing
                      let startOffset = window.innerHeight * (reverse ? config.end : config.start),
                          endOffset = window.innerHeight * (reverse ? config.start : config.end),
                          totalDistance = sections[0].offsetHeight * (sections.length - 1),
                          orientedSections = sections.slice(0);
                      if (reverse) {
                        orientedSections.reverse(); // we're animating down (backwards), so elements will come into view the opposite way.
                      }
                      orientedSections.forEach((elem, i) => {
                        let halfHeight = elem.offsetHeight / 2;
                        startOffset += halfHeight; // center of element
                        endOffset += halfHeight;
                        let startPosition = startOffset / totalDistance,
                            endPosition = endOffset / totalDistance;
                        if (startOffset <= totalDistance) {
                          actionsTL.add(() => config[(self.direction < 0 && reverse) || (self.direction > 0 && !reverse)  ? "onLeaveBack" : "onEnter"](elem), startOffset / totalDistance);
                        }
                        if (endOffset <= totalDistance) {
                          actionsTL.add(() => config[(self.direction < 0 && reverse) || (self.direction > 0 && !reverse)  ? "onEnterBack" : "onLeave"](elem), endOffset / totalDistance);
                        }
                        startOffset += halfHeight;
                        endOffset += halfHeight;
                      });
                    },
                    end: () => `+=${height*2}px`
                  }
              });
            scrollTween.to(sections, {
                yPercent: (reverse ? 100 : -100) * (sections.length - 1),
                duration: 1,
                ease: "none", // <-- IMPORTANT!
            });
            scrollTween.add(actionsTL, 0);
        }
        
        animateSection(sectionsMain, config, true);
        animateSection(sections1, config);
        animateSection(sections2, config, true);
        animateSection(sections3, config);
        


    },[])

    return (
      <div className='project' id='project'>
        <div className="container">
          <div className="parentOfItems">
              <div className="parent">
                  <div className="big-block">
                      <div className="big-1">
                          <a href="https://lasagna-jullemyth122.vercel.app/?fbclid=IwAR3wBzYklj6jiAPdk9wmCvzx86KdGlryDBaIxnzZZftO5k0-NWtnbqvIBPo">
                            <img src="./img/f9.png" alt="" />
                          </a>
                      </div>
                      <div className="big-2">
                          <a href="https://luminous-cucurucho-ebe2ab.netlify.app/?fbclid=IwAR29J1B8iuMNFja7t5nAC-M7PS4U0l502o759M0A0roUir7F27OcEou1tEo">
                            <img src="./img/f8.png" alt="" />
                          </a>
                      </div>
                      <div className="big-3">
                          <a href="#">
                            <img src="./img/f7.jpg" alt="" />
                          </a>
                      </div>
                      <div className="big-4">
                          <a href="https://hardcore-hermann-d5b875.netlify.app/?fbclid=IwAR3LNbGsSN6Vy9TAiWHx9hrKJ5vSH4QcXEMOS1fMzvEpEZ72CNXPU4QVZvM">
                            <img src="./img/f6.png" alt="" />
                          </a>
                      </div>
                      <div className="big-5">
                          <a href="https://jujutsu-kaisen-jullemyth122.vercel.app/">
                            <img src="./img/f5.png" alt="" />
                          </a>
                      </div>
                      <div className="big-6">
                          <a href="https://xenodochial-jennings-259d27.netlify.app/">
                            <img src="./img/f4.png" alt="" />
                          </a>
                      </div>
                      <div className="big-7">
                          <a href="https://fullstack-ecommerce-jullemyth122.vercel.app/">
                            <img src="./img/f3.png" alt="" />
                          </a>
                      </div>
                      <div className="big-8">
                          <a href="https://philippinewebsite.vercel.app/">
                            <img src='./img/f2.jpg' alt="" />
                          </a>
                      </div>
                      <div className="big-1">
                          <a href="https://lasagna-jullemyth122.vercel.app/?fbclid=IwAR3wBzYklj6jiAPdk9wmCvzx86KdGlryDBaIxnzZZftO5k0-NWtnbqvIBPo">
                            <img src="./img/f9.png" alt="" />
                          </a>
                      </div>
                      <div className="big-2">
                          <a href="https://luminous-cucurucho-ebe2ab.netlify.app/?fbclid=IwAR29J1B8iuMNFja7t5nAC-M7PS4U0l502o759M0A0roUir7F27OcEou1tEo">
                            <img src="./img/f8.png" alt="" />
                          </a>
                      </div>
                      <div className="big-3">
                          <a href="#">
                            <img src="./img/f7.jpg" alt="" />
                          </a>
                      </div>
                      <div className="big-4">
                          <a href="https://hardcore-hermann-d5b875.netlify.app/?fbclid=IwAR3LNbGsSN6Vy9TAiWHx9hrKJ5vSH4QcXEMOS1fMzvEpEZ72CNXPU4QVZvM">
                            <img src="./img/f6.png" alt="" />
                          </a>
                      </div>
                      <div className="big-5">
                          <a href="https://jujutsu-kaisen-jullemyth122.vercel.app/">
                            <img src="./img/f5.png" alt="" />
                          </a>
                      </div>
                      <div className="big-6">
                          <a href="https://xenodochial-jennings-259d27.netlify.app/">
                            <img src="./img/f4.png" alt="" />
                          </a>
                      </div>
                      <div className="big-7">
                          <a href="https://fullstack-ecommerce-jullemyth122.vercel.app/">
                            <img src="./img/f3.png" alt="" />
                          </a>
                      </div>
                      <div className="big-8">
                          <a href="https://philippinewebsite.vercel.app/">
                            <img src='./img/f2.jpg' alt="" />
                          </a>
                      </div>
                  </div>

                  <div className="block1">
                      <div className="c1">
                          <a href="#">
                            <img src="./img/f2_.png" alt="" />
                          </a>
                      </div>
                      <div className="c2">
                          <a href="https://fullstack-ecommerce-jullemyth122.vercel.app/">
                            <img src="./img/f3_.png" alt="" />
                          </a>
                      </div>
                      <div className="c3">
                          <a href="https://xenodochial-jennings-259d27.netlify.apphttps://philippinewebsite.vercel.app/">
                            <img src="./img/f4_.png" alt="" />
                          </a>
                      </div>
                      <div className="c4">
                          <a href="https://jujutsu-kaisen-jullemyth122.vercel.app/">
                            <img src="./img/f5_.png" alt="" />
                          </a>
                      </div>
                      <div className="c5">
                          <a href="https://hardcore-hermann-d5b875.netlify.app/?fbclid=IwAR3LNbGsSN6Vy9TAiWHx9hrKJ5vSH4QcXEMOS1fMzvEpEZ72CNXPU4QVZvM">
                            <img src="./img/f6_.png" alt="" />
                          </a>
                      </div>
                      <div className="c6">
                          <a href="#">
                            <img src="./img/f7_.jpg" alt="" />
                          </a>
                      </div>
                      <div className="c7">
                          <a href="https://luminous-cucurucho-ebe2ab.netlify.app/?fbclid=IwAR29J1B8iuMNFja7t5nAC-M7PS4U0l502o759M0A0roUir7F27OcEou1tEo">
                            <img src="./img/f8_.png" alt="" />
                          </a>
                      </div>
                      <div className="c8">
                          <a href="https://lasagna-jullemyth122.vercel.app/?fbclid=IwAR3wBzYklj6jiAPdk9wmCvzx86KdGlryDBaIxnzZZftO5k0-NWtnbqvIBPo">
                            <img src="./img/f9_.png" alt="" />
                          </a>
                      </div>
                      <div className="c1">
                          <a href="#">
                            <img src="./img/f2_.png" alt="" />
                          </a>
                      </div>
                      <div className="c2">
                          <a href="https://fullstack-ecommerce-jullemyth122.vercel.app/">
                            <img src="./img/f3_.png" alt="" />
                          </a>
                      </div>
                      <div className="c3">
                          <a href="https://xenodochial-jennings-259d27.netlify.apphttps://philippinewebsite.vercel.app/">
                            <img src="./img/f4_.png" alt="" />
                          </a>
                      </div>
                      <div className="c4">
                          <a href="https://jujutsu-kaisen-jullemyth122.vercel.app/">
                            <img src="./img/f5_.png" alt="" />
                          </a>
                      </div>
                      <div className="c5">
                          <a href="https://hardcore-hermann-d5b875.netlify.app/?fbclid=IwAR3LNbGsSN6Vy9TAiWHx9hrKJ5vSH4QcXEMOS1fMzvEpEZ72CNXPU4QVZvM">
                            <img src="./img/f6_.png" alt="" />
                          </a>
                      </div>
                      <div className="c6">
                          <a href="#">
                            <img src="./img/f7_.jpg" alt="" />
                          </a>
                      </div>
                      <div className="c7">
                          <a href="https://luminous-cucurucho-ebe2ab.netlify.app/?fbclid=IwAR29J1B8iuMNFja7t5nAC-M7PS4U0l502o759M0A0roUir7F27OcEou1tEo">
                            <img src="./img/f8_.png" alt="" />
                          </a>
                      </div>
                      <div className="c8">
                          <a href="https://lasagna-jullemyth122.vercel.app/?fbclid=IwAR3wBzYklj6jiAPdk9wmCvzx86KdGlryDBaIxnzZZftO5k0-NWtnbqvIBPo">
                            <img src="./img/f9_.png" alt="" />
                          </a>
                      </div>
                  </div>
                  
                  <div className="block2">
                      <div className="c1">
                          <a href="https://lasagna-jullemyth122.vercel.app/?fbclid=IwAR3wBzYklj6jiAPdk9wmCvzx86KdGlryDBaIxnzZZftO5k0-NWtnbqvIBPo">
                            <img src="./img/f9_1.png" alt="" />
                          </a>
                      </div>
                      <div className="c2">
                          <a href="https://luminous-cucurucho-ebe2ab.netlify.app/?fbclid=IwAR29J1B8iuMNFja7t5nAC-M7PS4U0l502o759M0A0roUir7F27OcEou1tEo">
                            <img src="./img/f8_1.png" alt="" />
                          </a>
                      </div>
                      <div className="c3">
                          <a href="#">
                            <img src="./img/f7_1.jpg" alt="" />
                          </a>
                      </div>
                      <div className="c4">
                          <a href="https://hardcore-hermann-d5b875.netlify.app/?fbclid=IwAR3LNbGsSN6Vy9TAiWHx9hrKJ5vSH4QcXEMOS1fMzvEpEZ72CNXPU4QVZvM">
                            <img src="./img/f6 _1.png" alt="" />
                          </a>
                      </div>
                      <div className="c5">
                          <a href="https://jujutsu-kaisen-jullemyth122.vercel.app/">
                            <img src="./img/f5_1.png" alt="" />
                          </a>
                      </div>
                      <div className="c6">
                          <a href="https://xenodochial-jennings-259d27.netlify.app/">
                            <img src="./img/f4_1.png" alt="" />
                          </a>
                      </div>
                      <div className="c7">
                          <a href="https://fullstack-ecommerce-jullemyth122.vercel.app/">
                            <img src="./img/f3_1.png" alt="" />
                          </a>
                      </div>
                      <div className="c8">
                          <a href="https://philippinewebsite.vercel.app/">
                            <img src="./img/f2_1.png" alt="" />
                          </a>
                      </div>
                      <div className="c1">
                          <a href="https://lasagna-jullemyth122.vercel.app/?fbclid=IwAR3wBzYklj6jiAPdk9wmCvzx86KdGlryDBaIxnzZZftO5k0-NWtnbqvIBPo">
                            <img src="./img/f9_1.png" alt="" />
                          </a>
                      </div>
                      <div className="c2">
                          <a href="https://luminous-cucurucho-ebe2ab.netlify.app/?fbclid=IwAR29J1B8iuMNFja7t5nAC-M7PS4U0l502o759M0A0roUir7F27OcEou1tEo">
                            <img src="./img/f8_1.png" alt="" />
                          </a>
                      </div>
                      <div className="c3">
                          <a href="#">
                            <img src="./img/f7_1.jpg" alt="" />
                          </a>
                      </div>
                      <div className="c4">
                          <a href="https://hardcore-hermann-d5b875.netlify.app/?fbclid=IwAR3LNbGsSN6Vy9TAiWHx9hrKJ5vSH4QcXEMOS1fMzvEpEZ72CNXPU4QVZvM">
                            <img src="./img/f6 _1.png" alt="" />
                          </a>
                      </div>
                      <div className="c5">
                          <a href="https://jujutsu-kaisen-jullemyth122.vercel.app/">
                            <img src="./img/f5_1.png" alt="" />
                          </a>
                      </div>
                      <div className="c6">
                          <a href="https://xenodochial-jennings-259d27.netlify.app/">
                            <img src="./img/f4_1.png" alt="" />
                          </a>
                      </div>
                      <div className="c7">
                          <a href="https://fullstack-ecommerce-jullemyth122.vercel.app/">
                            <img src="./img/f3_1.png" alt="" />
                          </a>
                      </div>
                      <div className="c8">
                          <a href="https://philippinewebsite.vercel.app/">
                            <img src="./img/f2_1.png" alt="" />
                          </a>
                      </div>
                  </div>

                  <div className="block3">
                      <div className="c1">
                          <a href="#">
                            <img src="./img/f2_2.png" alt="" />
                          </a>
                      </div>
                      <div className="c2">
                          <a href="https://fullstack-ecommerce-jullemyth122.vercel.app/">
                            <img src="./img/f3_2.png" alt="" />
                          </a>
                      </div>
                      <div className="c3">
                          <a href="https://xenodochial-jennings-259d27.netlify.apphttps://philippinewebsite.vercel.app/">
                            <img src="./img/f4_2.png" alt="" />
                          </a>
                      </div>
                      <div className="c4">
                          <a href="https://jujutsu-kaisen-jullemyth122.vercel.app/">
                            <img src="./img/f5_2.png" alt="" />
                          </a>
                      </div>
                      <div className="c5">
                          <a href="https://hardcore-hermann-d5b875.netlify.app/?fbclid=IwAR3LNbGsSN6Vy9TAiWHx9hrKJ5vSH4QcXEMOS1fMzvEpEZ72CNXPU4QVZvM">
                            <img src="./img/f6_2.png" alt="" />
                          </a>
                      </div>
                      <div className="c6">
                          <a href="#">
                            <img src="./img/f7_2.jpg" alt="" />
                          </a>
                      </div>
                      <div className="c7">
                          <a href="https://luminous-cucurucho-ebe2ab.netlify.app/?fbclid=IwAR29J1B8iuMNFja7t5nAC-M7PS4U0l502o759M0A0roUir7F27OcEou1tEo">
                            <img src="./img/f8_2.png" alt="" />
                          </a>
                      </div>
                      <div className="c8">
                          <a href="https://lasagna-jullemyth122.vercel.app/?fbclid=IwAR3wBzYklj6jiAPdk9wmCvzx86KdGlryDBaIxnzZZftO5k0-NWtnbqvIBPo">
                            <img src="./img/f8_2.png" alt="" />
                          </a>
                      </div>
                      <div className="c1">
                          <a href="#">
                            <img src="./img/f2_2.png" alt="" />
                          </a>
                      </div>
                      <div className="c2">
                          <a href="https://fullstack-ecommerce-jullemyth122.vercel.app/">
                            <img src="./img/f3_2.png" alt="" />
                          </a>
                      </div>
                      <div className="c3">
                          <a href="https://xenodochial-jennings-259d27.netlify.apphttps://philippinewebsite.vercel.app/">
                            <img src="./img/f4_2.png" alt="" />
                          </a>
                      </div>
                      <div className="c4">
                          <a href="https://jujutsu-kaisen-jullemyth122.vercel.app/">
                            <img src="./img/f5_2.png" alt="" />
                          </a>
                      </div>
                      <div className="c5">
                          <a href="https://hardcore-hermann-d5b875.netlify.app/?fbclid=IwAR3LNbGsSN6Vy9TAiWHx9hrKJ5vSH4QcXEMOS1fMzvEpEZ72CNXPU4QVZvM">
                            <img src="./img/f6_2.png" alt="" />
                          </a>
                      </div>
                      <div className="c6">
                          <a href="#">
                            <img src="./img/f7_2.jpg" alt="" />
                          </a>
                      </div>
                      <div className="c7">
                          <a href="https://luminous-cucurucho-ebe2ab.netlify.app/?fbclid=IwAR29J1B8iuMNFja7t5nAC-M7PS4U0l502o759M0A0roUir7F27OcEou1tEo">
                            <img src="./img/f8_2.png" alt="" />
                          </a>
                      </div>
                      <div className="c8">
                          <a href="#">
                            <img src="./img/f8_2.png" alt="" />
                          </a>
                      </div>
                  </div>
              </div>
          </div>
        </div>
      </div>
    )
}

export default Project